import { render, staticRenderFns } from "./CTableColumn.vue?vue&type=template&id=4c3c315d"
import script from "./CTableColumn.vue?vue&type=script&lang=js"
export * from "./CTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports